import {requestHelpers} from '../../helpers';

export const actions = {
  GET_TODO_LIST: 'GET_TODO_LIST',
  SET_TODO_LIST: 'SET_TODO_LIST',
  UPDATE_TODO_LIST: 'UPDATE_TODO_LIST'
};

export const getTodoList = (personId) => {
  return (dispatch) => {
    dispatch({
      type: actions.GET_TODO_LIST,
      isFetching: true
    });

    requestHelpers
      .authenticatedGetRequest(`/profiles/${personId}/todo-list`)
      .then((response) => {
        return dispatch({
          type: actions.SET_TODO_LIST,
          isFetching: false,
          body: response.data
        })
      })
      .catch((error) => {
        console.log('LOG: ERROR', error);
      })
  }
};

export const updateTodoList = (personId, listItem) => {
  return (dispatch) => {
    requestHelpers
      .authenticatedPutRequest(`/profiles/${personId}/todo-list-and-star-rating`, {list_item: listItem})
      .then((response) => {
        return dispatch({
          type: actions.UPDATE_TODO_LIST,
          success: response.success
        })
      })
      .catch((error) => {
        console.log('LOG: ERROR', error);
      })
  }
};





// WEBPACK FOOTER //
// src/client/actions/todo_list/todo_list.js